export default __webpack_public_path__ + "static/media/phone-app-expenses-right.a6f9eb2c.png";